export default {
  notilogin:"Попытка входа с нового устройства",
  notiwithdraw:"Вы успешно отозвали",
  notideposit:"Ты получила",
  notiexchange:'Обмен успешно выполнен'

};

